import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_anzaxnuac4: FaireBrandEntity = {
  token: "b_anzaxnuac4",
  type: "brand",
  name: "AIDA di Giangreco",
  avatarUrl:
    "https://cdn.faire.com/fastly/b65ca92c9ac6140e7885c0db171d081a3f80b99b676cd5c7f7b4a669667aeabb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c4947764c374a729094e9ea0025de62af9e10838770ab940ca55caadff60a71a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b65ca92c9ac6140e7885c0db171d081a3f80b99b676cd5c7f7b4a669667aeabb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c4947764c374a729094e9ea0025de62af9e10838770ab940ca55caadff60a71a.jpeg",
  location: "Assoro, ITA",
  minimumOrderDollars: 108,
  rating: 4.9,
  reviewCount: 29,
  isInsider: false,
  description:
    "AIDA BIO® was born from the transformation of an artisan company with a long family tradition led by Giangreco Paolo.\n\nGiangreco Paolo, a member of one of the most prestigious Sicilian families in the field of confectionery production, has inherited the ancient recipes jealously guarded by the family.\n\nFounded in ASSORO (EN) in 1930 by Antonino Giangreco as a farm with production first of milk and later of almonds and honey, over time it has been transformed into a bakery with a laboratory adjoining for sweets. In 1990, the A.I.D.A. of Giangreco managed to establish itself not only in the local market, but at a national and international level, exporting the products to most European countries.\n\nIn 2010 the company became s.r.l. under the name AIDA BIO to emphasize the main characteristic of products that favor raw materials with excellent organic qualities and with the prospect of create a line dedicated entirely to organic.\n\nIn fact, the company's strengths derive from a strong respect for Sicilian raw materials and traditions combined with the promotion of a traditional and healthy food culture. The company philosophy has been the guarantee and the quality mark of the entire production and represents Sicilian authenticity in foreign markets.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:51.443Z",
    importedBy: "entity-db-cli",
  },
};
